export default {
  meta: {
    title: '权限管理'
  }
};
